import { BaseAction } from "../../common";
const MODULE_PREFIX = 'VEHICLE_INFO';
export const SELECTION_METHOD_CHANGED = `${MODULE_PREFIX}_SELECTION_METHOD_CHANGED`;
export const FLYOUT_CLICKED = `${MODULE_PREFIX}_FLYOUT_CLICKED`;
export const ON_VALID_VIN_DATA = `${MODULE_PREFIX}_ON_VALID_VIN_DATA`;
export const ON_VIN_UPDATED = `${MODULE_PREFIX}_ON_VIN_UPDATED`;
export const ON_VEHICLE_INFO_UPDATED = `${MODULE_PREFIX}_ON_VEHICLE_INFO_UPDATED`;
export const ON_INVALID_VIN_DATA = `${MODULE_PREFIX}_ON_INVALID_VIN_DATA`;
export const ON_VEHICLE_IDENTIFICATION_ERROR_UPDATE = `${MODULE_PREFIX}_ON_VEHICLE_IDENTIFICATION_ERROR_UPDATE`;
export const ON_RESET_VEHICLE_INFO = `${MODULE_PREFIX}_ON_RESET_VEHICLE_INFO`;
export const ON_VEHICLE_RESOLVED = `${MODULE_PREFIX}_ON_VEHICLE_RESOLVED`;
export const ON_VSS_ERROR_UPDATE = `${MODULE_PREFIX}_ON_VSS_ERROR_UPDATE`;
export const ON_GENERIC_VEHICLE_LOAD = `${MODULE_PREFIX}_ON_GENERIC_VEHICLE_LOAD`;
export const ON_VEHICLE_RESOLVED_ON_LOAD = `${MODULE_PREFIX}_ON_VEHILCE_RESOLVED_ON_LOAD`;
export const VEHICLE_INFO_UPDATE_VEHICLE_SELECTION_METHOD = `${MODULE_PREFIX}_UPDATE_VEHICLE_SELECTION_METHOD`;
export class VinUpdatedAction extends BaseAction {
}
export class VinDecodeRequestedAction extends BaseAction {
}
export class VinDecodeFailedAction extends BaseAction {
}
export class VehicleInfoUpdatedAction extends BaseAction {
}
export class FlyoutClickedAction extends BaseAction {
}
export class SelectionMethodChangedAction extends BaseAction {
}
export class VehicleIdentificationErrorUpdateAction extends BaseAction {
}
export class VssErrorUpdateAction extends BaseAction {
}
export class ResetVehicleInfoAction extends BaseAction {
}
export class IVehicleResolvedAction extends BaseAction {
}
export const onSelectionMethodChanged = (vehicleInfo, vehicleSelectionMethod) => ({
    type: SELECTION_METHOD_CHANGED,
    payload: {
        vehicleInfo,
        vehicleSelectionMethod
    }
});
export const onFlyoutClicked = (vehicleInfo, vehicleInfoEntry, vehicleSelectionHierarchyLabel, vehicleSelectionMethod) => ({
    type: FLYOUT_CLICKED,
    payload: {
        vehicleInfo,
        vehicleInfoEntry,
        vehicleSelectionHierarchyLabel,
        vehicleSelectionMethod
    }
});
export const onVehicleResolvedOnLoad = (vehicleInfo, vin, vid, serviceBarcode) => ({
    type: ON_VEHICLE_RESOLVED_ON_LOAD,
    payload: { vehicleInfo, vin, vid, serviceBarcode }
});
export const onGenericVehicleLoad = (payload) => ({
    type: ON_GENERIC_VEHICLE_LOAD,
    payload
});
export const onValidVinData = (vehicleInfo, vin, vid, serviceBarcode, hasSelectionMethodChanged) => ({
    type: ON_VALID_VIN_DATA,
    payload: { vehicleInfo, vin, vid, serviceBarcode, hasSelectionMethodChanged }
});
export const onVinUpdated = (vin, vehicleSelectionMethod) => ({
    type: ON_VIN_UPDATED,
    payload: { vin, vehicleSelectionMethod }
});
export const onInvalidVinData = vin => ({
    type: ON_INVALID_VIN_DATA,
    payload: { vin }
});
export const onVehicleInfoUpdated = vehicleInfo => ({
    type: ON_VEHICLE_INFO_UPDATED,
    payload: { vehicleInfo }
});
export const onVehicleIdentificationErrorUpdated = payload => ({
    type: ON_VEHICLE_IDENTIFICATION_ERROR_UPDATE,
    payload
});
export const onVssErrorUpdated = errorPayload => ({
    type: ON_VSS_ERROR_UPDATE,
    payload: { errorPayload: errorPayload }
});
export const onResetVehicleInfo = (vehicleSelectionMethod, vin) => ({
    type: ON_RESET_VEHICLE_INFO,
    payload: {
        vehicleSelectionMethod,
        vin
    }
});
export const onVehicleResolved = vehicleInfo => ({
    type: ON_VEHICLE_RESOLVED,
    payload: {
        vehicleInfo
    }
});
export const updateVehicleSelectionMethodAction = (vehicleSelectionMethod) => ({
    type: VEHICLE_INFO_UPDATE_VEHICLE_SELECTION_METHOD,
    payload: { vehicleSelectionMethod }
});
//# sourceMappingURL=actions.js.map